export const ru = {
    title: 'Добавьте документы',
    description: 'Они нужны для покупки билетов и брони отелей',
    add_later: 'Может позже',
    add_now: 'Добавить',
};
